import './MetadataContainer.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Descriptions } from 'antd';
import { DetailSection } from '../DetailSection';
import { isBoolean } from '@sonar-software/sonar-ts-lib';
import React from 'react';

export type MetadataEntryType = 'string' | 'boolean' | 'array';

export interface MetadataEntry {
	bold?: boolean;
	label: string;
	type: MetadataEntryType;
	value: string | boolean | Array<string> | Date | null | undefined;
}

export interface MetadataContainerProps {
	entries: MetadataEntry[];
	title?: string;
}

function getArrayValueRow(entry: string, index: number): React.ReactNode {
	const displayEntry = `${index + 1}: ${entry}`;

	return (
		<div key={ entry }>
			{ displayEntry }
			<br />
		</div>
	);
}

function getValue(
	value: string | boolean | Array<string> | Date | null | undefined,
	type: MetadataEntryType
): string | React.ReactNode {
	switch (type) {
	case 'boolean':
		const isValid = isBoolean(value);

		if (!isValid) {
			return '';
		}

		return value ? COPY_SPECIFIC.YES : COPY_SPECIFIC.NO;
	case 'string':
		return (value ?? '').toString()?.trim();
	case 'array':
		if (!value) {
			return '';
		}

		const valueArray = value as Array<string>;

		return <div>{ valueArray.map((entry, index) => getArrayValueRow(entry, index)) }</div>;
	default:
		return '';
	}
}

function determineClassName(metadataEntry: MetadataEntry): string {
	return classNames({ title: metadataEntry.bold });
}

export const MetadataContainer: React.FC<MetadataContainerProps> = ({ entries, title }) => {
	if (!entries.length) {
		return null;
	}

	return (
		<DetailSection
			className='periscope-metadata-wrapper'
			title={ title }>
			<Descriptions
				bordered
				column={ 1 }
				size='small'>
				{ entries.map((entry) =>
					<Descriptions.Item
						className={ determineClassName(entry) }
						key={ entry.label }
						label={ entry.label }>
						{ getValue(entry.value, entry.type) }
					</Descriptions.Item>) }
			</Descriptions>
		</DetailSection>
	);
};
